module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Set measurement","placeholder":"Enter a number (mm)"},"no":{"title":"Sett mål","placeholder":"Skriv inn ett tall (mm)"}}')
  delete Component.options._Ctor
}
